import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import GlobalStyle from './Styles/GlobalStyle';
import { RecoilRoot } from 'recoil';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { GoogleOAuthProvider } from '@react-oauth/google';
import * as Sentry from '@sentry/react';

Sentry.init({
	dsn: 'https://4d86f97736a49e637a56621a97359873@o4510484023083008.ingest.us.sentry.io/4510707638140928',

	integrations: [Sentry.consoleLoggingIntegration({ levels: ['error'] })],

	tracesSampleRate: 1,
	// Setting this option to true will send default PII data to Sentry.
	// For example, automatic IP address collection on events
	tracePropagationTargets: ['localhost', 'https://dev.service.go-pang.com', 'https://service.go-pang.com'],

	sendDefaultPii: true,
	environment: process.env.NODE_ENV,
});

Sentry.setTag('SESSION_ID', (window as any).__APP__SESSION_ID__ ?? 'TEST');
Sentry.setContext('SESSION_ID', (window as any).__APP__SESSION_ID__ ?? 'TEST');

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
	<GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID}>
		<GlobalStyle />
		<BrowserRouter>
			<RecoilRoot>
				<QueryClientProvider client={queryClient}>
					<App />
				</QueryClientProvider>
			</RecoilRoot>
		</BrowserRouter>
	</GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
